/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsIcMemoryUsage } from "../../funcs/metricsGetApiV3MetricsIcMemoryUsage.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3MetricsIcMemoryUsageRequest$inboundSchema
    .optional(),
};

export const tool$metricsGetApiV3MetricsIcMemoryUsage: ToolDefinition<
  typeof args
> = {
  name: "metrics-get-api-v3-metrics-ic-memory-usage",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await metricsGetApiV3MetricsIcMemoryUsage(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
